export default {
  title: 'Aangepaste drukproducten',
  fields: {
    name: 'Naam',
    format: 'Producttype',
  },
  buttons: {
    upload_product: 'Uploadproces starten',
    preview: 'Voorbeeld',
    edit: 'Bewerken',
  },
};
